import AddIcon from "@mui/icons-material/Add";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import TuneIcon from "@mui/icons-material/Tune";
import {
  Box,
  Container,
  Grid,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Toolbar,
  Typography,
} from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { flushSync } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Custom3dotString from "../../../components/Custom3dotString";
import CustomButton from "../../../components/CustomButton";
import {
  default as Checkbox,
  default as CustomCheckbox,
} from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomSwitch from "../../../components/CustomSwitch";
import CustomTextField from "../../../components/CustomTextField";
import { default as Select } from "../../../components/Select/Select";
import TopBar from "../../../components/TopBar/TopBar";
import {
  createClinicDoctors,
  createOthers,
  getClinicFacilities,
  getClinicRoles,
} from "../../../redux/reducers/clinicSlice";
import { showSnackBar } from "../../../redux/reducers/snackSlice";
import {
  getClinicVetsWithFilter,
  updateVetBlockStatus,
} from "../../../redux/reducers/vetSlice";
import { AppColors } from "../../../util/AppColors";
import { ErrorStrings } from "../../../util/ErrorString";
import { EmailRegex } from "../../../util/Validations";
import { newRoleList } from "../../../util/arrayList";
import {
  clinicRolesList,
  salutationList,
  specialtyList,
  typeList,
} from "../../../util/dropList";
import { tblGrayBack } from "../../../util/object";
import generatePass from "../../../util/randomPassword";
import Department from "../ComingSoon/cards/Department";
import Schedule from "../ComingSoon/cards/Schedule";
import CommonPaymentUpdateModal from "../CommonPaymentUpdateModal/CommonPaymentUpdateModal";
import Main from "./VetCharts.js/Main";
import "./Vets.css";

const filterList = [
  { label: "All", name: "All", value: "all" },
  { label: "Others", name: "Others", value: "other" },
  { label: "Vets", name: "Vets", value: "doctor" },
];

const nameExpan = {
  salutation: "Salutation",
  name: "Name",
  speciality: "Speciality",
  facility: "Facility",
  conType: "Consultation Type",
  contactNumber: "Contact Number",
  email: "Email",
  password: "Password",
  role: "Role",
  access: "Access",
  calIcon: "",
  toggleIcon: "",
};

const initialValues = {
  salutation: null,
  name: "",
  speciality: [],
  facility: null,
  contactNumber: "",
  conType: [],
  email: "",
  password: "",
  role: null,
  registrationNo: "",
  access: [],
  department: null,
};

const initialError = {
  salutation: false,
  name: false,
  speciality: false,
  facility: false,
  conType: false,
  contactNumber: false,
  email: false,
  password: false,
  role: false,
  access: false,
};

const initialHelp = {
  salutation: "",
  name: "",
  speciality: "",
  facility: "",
  conType: "",
  contactNumber: "",
  email: "",
  password: "",
  role: "",
  access: "",
};

const vetReqFlds = [
  "name",
  "role",
  // "access",
  "speciality",
  "conType",
  "email",
  "password",
];
const othersReqFlds = [
  "name",
  "role",
  //  "access",
  "email",
  "password",
];
const tblHeaders = [
  "name",
  "speciality",
  "role",
  "conType",
  "calIcon",
  "toggleIcon",
];

const initSearch = { vetName: "", speciality: [], phone: "", email: "" };
const filterByList = ["Type", "Role", "Department", "Consultation Type"];
const initFilter = {
  visible: false,
  added: false,
  selectedList: [],
  values: { Type: null },
};

const Vets = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState("content");
  const [conModVisible, setConModVisible] = useState(false);
  const [vetValues, setVetValues] = useState(initialValues);
  const [vetErrors, setVetErrors] = useState(initialError);
  const [vetHelps, setVetHelps] = useState(initialHelp);
  const [showPassword, setShowPassword] = useState(false);
  const [isAutoGenPass, setAutoGenPass] = useState(false);
  const [selectedVet, setSelectedVet] = useState(null);
  const [searchValues, setSearchValues] = useState(initSearch);
  const [searchValue, setSearchValue] = useState("");
  const [createModVisible, setCreateModalVisible] = useState(false);
  const [createUserType, setCreateUserType] = useState("Vet");
  const [subTab, setSubTab] = useState(null);
  const [vetAnchorEl, setVetAnchorEl] = useState(null);
  const [filterValues, setFilterValues] = useState(initFilter);
  const { vetList: vets } = useSelector((state) => state?.vet);
  const { clinicRoles, facilities } = useSelector((state) => state?.clinic);
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const { dataSharing: branchesDataSharing } = useMemo(() => {
    if (!mandateDataRaw) {
      return { dataSharing: {} };
    }
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return {
        dataSharing: reqData?.dataSharing ?? {},
      };
    } catch {
      return { dataSharing: {} };
    }
  }, [mandateDataRaw]);

  useEffect(() => {
    // onVetsApiCall();
    // dispatch(getGlobalDays());

    //for calling the init api call to load the data
    // onVetsApiCall(true);

    dispatch(getClinicRoles());
    dispatch(getClinicFacilities());
    // dispatch(getBranchesDataSharing());
    // Reset filter values to initial state when component mounts
    setFilterValues({
      ...initFilter,
      selectedList: [],
      values: { Type: null },
    });
  }, []);

  useEffect(() => {
    // Only call API if there are actual search values
    // const hasSearchValues =
    //   searchValues?.vetName?.trim() ||
    //   searchValues?.phone?.trim() ||
    //   searchValues?.email?.trim() ||
    //   (searchValues?.speciality && searchValues?.speciality?.length > 0);

    // if (hasSearchValues) {
    onVetsApiCall();
    // }
  }, [
    searchValues?.vetName,
    searchValues?.phone,
    searchValues?.email,
    searchValues?.speciality,
  ]);

  // const getVetDataAccess = () => {
  //   const profileMat = branchesDataSharing?.find(
  //     (li) => li?.createdBy === profile?.id,
  //   );
  //   return (
  //     (profileMat ? profileMat?.vetData : branchesDataSharing?.[0]?.vetData) ??
  //     false
  //   );
  // };

  const getFilterObj = (reset = false) => {
    const reqObj = {
      type: ["all"],
      vetData: branchesDataSharing?.vetData,
      // getVetDataAccess(),
      // type: filterValues?.values?.type,
      // filterValues?.values?.type?.includes("all")?['all']:filterValues?.values?.type
    };
    if (reset) return reqObj;
    if (filterValues?.values?.Type?.length > 0) {
      reqObj.type = [filterValues?.values?.Type];
    }
    if (searchValues?.vetName?.length > 0) reqObj.name = searchValues?.vetName;
    if (searchValues?.phone?.length > 0) reqObj.phone = searchValues?.phone;
    if (searchValues?.email?.length > 0) reqObj.email = searchValues?.email;
    if (searchValues?.speciality?.length > 0)
      reqObj.specialities = searchValues?.speciality?.map((li) => li?.name);
    if (filterValues?.values?.Role?.length > 0)
      reqObj.roles = filterValues?.values?.Role?.map((li) => li?.value);
    if (filterValues?.values?.["Consultation Type"]?.length > 0)
      reqObj.consultationTypes = filterValues?.values?.[
        "Consultation Type"
      ]?.map((li) => li?.value);
    if (filterValues?.values?.Department?.length > 0)
      reqObj.departments = filterValues?.values?.Department?.map(
        (li) => li?.value,
      );
    return reqObj;
  };

  const onVetsApiCall = (reset = false) => {
    dispatch(getClinicVetsWithFilter(getFilterObj(reset)));
  };

  const getAllFilteredList = () => {
    return vets?.vets
      ?.filter((vet) => {
        return (vet?.name?.toLowerCase() || "")?.includes(
          searchValue?.toLowerCase(),
        );
      })
      ?.map((li) => ({
        ...li,
        conType: li?.consulationType ? li?.consulationType?.join(", ") : "-",
        speciality: li?.speciality ? li?.speciality : "-",
      }));
  };

  const filteredVets = () => {
    return vets?.vets
      ?.filter((vet) => {
        const isVet = vet?.userType?.find(
          (usrTyp) => usrTyp?.name === "ROLE_DOCTOR",
        );
        return (
          isVet &&
          (vet?.name?.toLowerCase() ?? "")?.includes(searchValue?.toLowerCase())
        );
      })
      ?.map((li) => ({
        ...li,
        conType: li?.consulationType ? li?.consulationType?.join(", ") : "-",
        speciality: li?.speciality ? li?.speciality : "-",
      }));
  };

  const filteredOthers = () => {
    return vets?.vets
      ?.filter((vet) => {
        const otherUsers = vet?.userType?.find(
          (usrTyp) => usrTyp?.name !== "ROLE_DOCTOR",
        );
        return (
          otherUsers &&
          (vet?.name?.toLowerCase() ?? "")?.includes(searchValue?.toLowerCase())
        );
      })
      ?.map((li) => ({
        ...li,
        conType: li?.consulationType ? li?.consulationType?.join(", ") : "-",
        speciality: li?.speciality ? li?.speciality : "-",
      }));
  };

  const conModalOpen = () => {
    setConModVisible(!conModVisible);
  };

  const emailValidation = (value) => {
    if (value === "") {
      setVetErrors({ ...vetErrors, email: true });
      setVetHelps({ ...vetHelps, email: ErrorStrings.emptyEmail });
    }
    if (value !== "") {
      if (!EmailRegex.test(value)) {
        setVetErrors({ ...vetErrors, email: true });
        setVetHelps({ ...vetHelps, email: ErrorStrings.inValidEmail });
      } else {
        setVetErrors({ ...vetErrors, email: false });
        setVetHelps({ ...vetHelps, email: "" });
      }
    }
  };

  const passValidation = (value) => {
    if (value === "") {
      setVetErrors({ ...vetErrors, password: true });
      setVetHelps({ ...vetHelps, password: ErrorStrings.emptyPass });
      return;
    }
    if (value?.length < 6) {
      setVetErrors({ ...vetErrors, password: true });
      setVetHelps({ ...vetHelps, password: ErrorStrings.inValidPass });
      return;
    }
    setVetErrors({ ...vetErrors, password: false });
    setVetHelps({ ...vetHelps, password: "" });
  };

  const mobileValidation = (value) => {
    if (value === "") {
      setVetErrors({ ...vetErrors, contactNumber: true });
      setVetHelps({ ...vetHelps, contactNumber: ErrorStrings.emptyMobile });
      return;
    }
    if (value.length < 10 || value.length > 10) {
      setVetErrors({ ...vetErrors, contactNumber: true });
      setVetHelps({ ...vetHelps, contactNumber: ErrorStrings.inValidMobile });
      return;
    }
    setVetErrors({ ...vetErrors, contactNumber: false });
    setVetHelps({ ...vetHelps, contactNumber: "" });
  };

  const handleChange = (e) => {
    setVetValues({ ...vetValues, [e.target.name]: e.target.value });
    if (e.target.name === "email") return emailValidation(e.target.value);
    if (e.target.name === "password") return passValidation(e.target.value);
    if (e.target.name === "contactNumber") {
      return mobileValidation(e.target.value);
    }
    const { name, value } = e.target;
    if (vetErrors[name]) {
      setVetErrors({ ...vetErrors, [name]: false });
      setVetHelps({ ...vetHelps, [name]: "" });
    }

    setVetValues({
      ...vetValues,
      [name]:
        name === "name"
          ? value?.charAt(0).toUpperCase() + value?.slice(1)
          : value,
    });

    if (e.target.value === "") {
      setVetErrors({ ...vetErrors, [e.target.name]: true });
      setVetHelps({
        ...vetHelps,
        [e.target.name]: `${nameExpan?.[e.target.name]} Required Field`,
      });
    }
    if (e.target.value !== "") {
      setVetErrors({ ...vetErrors, [e.target.name]: false });
      setVetHelps({ ...vetHelps, [e.target.name]: "" });
    }
  };

  const handleMultiSelect = (event, name) => {
    const {
      target: { value },
    } = event;
    const reqValue =
      name === "access"
        ? value?.includes("Admin")
          ? ["Admin"]
          : value
        : value;
    setVetValues({
      ...vetValues,
      [name]: reqValue,
    });
    setVetErrors({
      ...vetErrors,
      [name]: reqValue?.length > 0 ? false : true,
    });
    setVetHelps({
      ...vetHelps,
      [name]: reqValue?.length > 0 ? "" : `${nameExpan?.[name]} Required Field`,
    });
  };

  const handleSelect = (value, key) => {
    if (vetErrors[key]) {
      setVetErrors({ ...vetErrors, [key]: false });
      setVetHelps({ ...vetHelps, [key]: "" });
    }
    setVetValues({ ...vetValues, [key]: value });
  };

  const handleChangeSwitch = async (e, vet) => {
    dispatch(
      updateVetBlockStatus({
        vetId: vet?.doctorId,
        active: e.target.value ? "Y" : "N",
      }),
    ).then((res) => {
      if (res?.payload) {
        onVetsApiCall();
        // dispatch(getClinicVets(`?type=${vetFilter}`));
      }
    });
  };

  const checkRoleDoctor = (vet) => {
    const roleDoctor = vet?.userType?.find(
      (usr) => usr?.name === "ROLE_DOCTOR",
    );
    return roleDoctor ? true : false;
  };

  const handleCardClick = (vet) => {
    // if (!checkRoleDoctor(vet)) return;
    navigate("/vet-calendar", { state: { vet } });
  };

  const handleUpdateFeeUpdateSuccess = async () => {
    setSelectedVet(null);
    setConModVisible(!conModVisible);
    onVetsApiCall();
    // dispatch(getClinicVets(`?type=${vetFilter}`));
  };

  const handleAutoGenPassword = () => {
    setAutoGenPass(!isAutoGenPass);
    if (!isAutoGenPass) {
      const pass = generatePass();
      setVetValues({ ...vetValues, password: pass });
    } else {
      setVetValues({ ...vetValues, password: "" });
    }
  };

  const onClickCalendar = (vet) => {
    // if (!checkRoleDoctor(vet)) return;
    navigate("/manage-availability", { state: { vetId: vet?.doctorId } });
  };

  const onClickDollar = (vet) => {
    // if (!checkRoleDoctor(vet)) return;
    setSelectedVet(vet);
    if (vet?.active === "Y") {
      setConModVisible(!conModVisible);
    }
  };

  const handleCreate = () => {
    setCreateModalVisible(true);
  };

  const createModalOpen = () => {
    setCreateUserType("Vet");
    setCreateModalVisible(!createModVisible);
    setVetValues(initialValues);
    setVetErrors(initialError);
    setVetHelps(initialHelp);
  };

  const handleChangeUserType = (e) => {
    setCreateUserType(e.target.value);
    setVetValues(initialValues);
    setVetErrors(initialError);
    setVetHelps(initialHelp);
  };

  const resetValues = () => {
    setVetValues(initialValues);
    setVetErrors(initialError);
    setVetHelps(initialHelp);
  };

  const handleSuccess = () => {
    dispatch(
      showSnackBar({
        message: "Clinic Vet Registered",
        type: "success",
      }),
    );
    setCreateModalVisible(false);
    resetValues();
    onVetsApiCall();
    // dispatch(getClinicVets(`?type=${vetFilter}`));
  };

  const createVet = () => {
    let errs = {};
    let helps = {};
    vetReqFlds?.forEach((fld) => {
      if (
        vetValues?.[fld] === null ||
        vetValues?.[fld] === "" ||
        (Array.isArray(vetValues?.[fld]) && vetValues?.[fld]?.length === 0) ||
        (fld === "password" && vetValues?.[fld]?.length < 6) ||
        (fld === "email" && !EmailRegex.test(vetValues?.[fld]))
      ) {
        errs = { ...errs, [fld]: true };
        helps = {
          ...helps,
          [fld]:
            fld === "email"
              ? vetValues?.[fld] === ""
                ? ErrorStrings.emptyEmail
                : !EmailRegex.test(vetValues?.[fld])
                  ? ErrorStrings.inValidEmail
                  : ""
              : fld === "password"
                ? vetValues?.[fld] === ""
                  ? ErrorStrings.emptyPass
                  : vetValues?.[fld]?.length < 6
                    ? ErrorStrings.inValidPass
                    : ""
                : `${nameExpan?.[fld]} Required Field`,
        };
      } else {
        errs = { ...errs, [fld]: false };
        helps = { ...helps, [fld]: "" };
      }
    });
    setVetErrors({ ...vetErrors, ...errs });
    setVetHelps({ ...vetHelps, ...helps });
    if (Object.keys(errs)?.some((val) => errs?.[val] === true)) return;
    // Proceed with vet creation if all validations pass
    const data = new FormData();
    data.append("name", vetValues?.name);
    // data.append("salutation", "Dr.");
    data.append(
      "speciality",
      vetValues?.speciality?.map((li) => li?.value),
    );
    // data.append("speciality", vetValues?.speciality?.value);
    data.append("role", vetValues?.role?.value);
    data.append("department", vetValues?.department?.value ?? null);
    data.append("email", vetValues?.email);
    data.append("password", vetValues?.password);
    data.append("consulationType", vetValues.conType);
    data.append("mobile", vetValues?.contactNumber);
    data.append(
      "access",
      vetValues?.role?.apiValue ?? "VET",
      // vetValues?.access?.map(
      //   (ac) => accessList.find(({ value }) => value === ac)?.apiValue
      // )
    );
    if (vetValues?.registrationNo !== "") {
      data.append("registrationNo", vetValues?.registrationNo ?? "");
    }
    if (vetValues?.facility?.value) {
      data.append("facility", vetValues?.facility?.value);
    }
    dispatch(createClinicDoctors(data))
      .then((res) => {
        if (res?.payload?.status === 200) {
          if (res?.payload?.data?.status === 400) {
            dispatch(
              showSnackBar({
                message: res?.payload?.data?.message,
                type: "error",
              }),
            );
          }
          if (res?.payload?.data?.status === 200) {
            if (
              res?.payload?.data?.message === "User profile created" ||
              res?.payload?.data?.message ===
                "Doctor profile created successfully"
            ) {
              handleSuccess();
            }
          }
        }
        if (res?.payload?.status === 500) {
          if (
            res?.payload?.response?.data?.error === "Internal Server Error" &&
            res?.payload?.response?.data?.message === "Authentication failed"
          ) {
            handleSuccess();
          }
        }
      })
      .catch((error) => {
        console.error("API call failed:", error);
      });
  };

  const createOther = () => {
    // Validate fields
    let errs = {};
    let helps = {};
    othersReqFlds?.forEach((fld) => {
      if (
        vetValues?.[fld] === null ||
        vetValues?.[fld] === "" ||
        (Array.isArray(vetValues?.[fld]) && vetValues?.[fld]?.length === 0) ||
        (fld === "password" && vetValues?.[fld]?.length < 6) ||
        (fld === "email" && !EmailRegex.test(vetValues?.[fld]))
      ) {
        errs = { ...errs, [fld]: true };
        helps = {
          ...helps,
          [fld]:
            fld === "email"
              ? vetValues?.[fld] === ""
                ? ErrorStrings.emptyEmail
                : !EmailRegex.test(vetValues?.[fld])
                  ? ErrorStrings.inValidEmail
                  : ""
              : fld === "password"
                ? vetValues?.[fld] === ""
                  ? ErrorStrings.emptyPass
                  : vetValues?.[fld]?.length < 6
                    ? ErrorStrings.inValidPass
                    : ""
                : `${nameExpan?.[fld]} Required Field`,
        };
      } else {
        errs = { ...errs, [fld]: false };
        helps = { ...helps, [fld]: "" };
      }
    });
    setVetErrors({ ...vetErrors, ...errs });
    setVetHelps({ ...vetHelps, ...helps });
    if (Object.keys(errs)?.some((val) => errs?.[val] === true)) return;

    // Proceed with vet creation if all validations pass
    const data = new FormData();
    data.append("name", vetValues?.name);
    data.append("role", vetValues?.role?.value);
    data.append("salutation", vetValues?.salutation?.value);
    data.append("registrationNo", vetValues?.registrationNo);
    data.append("department", vetValues?.department?.value ?? null);
    data.append("email", vetValues?.email);
    data.append("password", vetValues?.password);
    data.append("mobile", vetValues?.contactNumber);
    data.append(
      "access",
      vetValues?.role?.apiValue,
      // vetValues?.access?.map(
      //   (ac) => accessList.find(({ value }) => value === ac)?.apiValue
      // )
    );
    if (vetValues?.facility?.value) {
      data.append("facility", vetValues?.facility?.value);
    }
    dispatch(createOthers(data)).then((res) => {
      if (res?.payload?.data?.status === 200) {
        if (res?.payload?.data?.message === "User Registered Successfully") {
          dispatch(
            showSnackBar({
              message: res?.payload?.data?.message,
              type: "success",
            }),
          );
          setCreateModalVisible(false);
          resetValues();
          onVetsApiCall();
          // dispatch(getClinicVets(`?type=${vetFilter}`));
        } else {
          dispatch(
            showSnackBar({
              message: res?.payload?.data?.message,
              type: "error",
            }),
          );
        }
      }
    });
  };

  const getDepartments = () => {
    return clinicRoles
      ?.filter((li) => li?.type === "department")
      ?.map((li) => ({
        name: li?.roleName,
        value: li?.roleName,
      }));
  };

  const handleChangeMaster = (val) => {
    setSelectedTab("Master");
    setSubTab(val);
  };

  const handleChangeTab = (tab) => {
    setSelectedTab(tab);
    setSubTab(null);
  };

  const onSearchChange = (e) => {
    const { name, value } = e?.target;
    setSearchValues({
      ...searchValues,
      [name?.trim()?.replace(/,$/, "")]: value, // remove spaces & trailing commas
    });
  };

  const onFilterChange = (name, value) => {
    const reqObj = { ...filterValues, [name]: value };
    setFilterValues(reqObj);
  };

  const onCloseFilter = () => {
    const reqObj = { ...filterValues, visible: false };
    setFilterValues(reqObj);
    // if (filterValues?.selectedList?.length === 0) return;
    // onVetsApiCall();
  };

  const onSelectFilter = (name) => {
    const reqObj = { ...filterValues };
    let reqList = filterValues?.selectedList;
    if (reqList?.includes(name)) {
      reqList = reqList?.filter((item) => item !== name);
    } else {
      reqList.push(name);
    }
    reqObj.selectedList = reqList;
    setFilterValues(reqObj);
  };

  const onFilterAdd = (value) => {
    const reqObj = { ...filterValues, added: value };
    setFilterValues(reqObj);
  };

  const onReset = () => {
    flushSync(() => {
      setSearchValues(initSearch);
    });
    flushSync(() => {
      setFilterValues({
        ...initFilter,
        selectedList: [],
        values: { Type: null },
      });
    });
    onVetsApiCall(true);
  };

  const onFilterReset = () => {
    const reqObj = {
      ...initFilter,
      visible: true,
      selectedList: [],
      values: { Type: null },
    };
    setFilterValues(reqObj);
  };

  const onFilterValuesChange = (e) => {
    const { name, value } = e?.target;
    const reqObj = {
      ...filterValues,
      values: {
        ...filterValues?.values,
        [name?.trim()?.replace(/,$/, "")]: value,
      },
    };
    setFilterValues(reqObj);
  };

  const onApplyFilter = () => {
    onVetsApiCall();
    const reqObj = { ...filterValues, visible: false };
    setFilterValues(reqObj);
  };

  const facilityList = () => {
    return (
      facilities?.map((fl) => {
        return { name: fl?.name, value: fl?.facilityId, id: fl?.facilityId };
      }) ?? []
    );
  };

  return (
    <>
      <TopBar>
        <Container maxWidth="xl">
          <Grid container spacing={0} className="flex-center">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Grid container spacing={0}>
                <div className="flex-row-ali-cen">
                  <div
                    className="ph10pv3"
                    onClick={() => handleChangeTab("dashboard")}
                  >
                    <div
                      className={`flex-center cursor ${
                        selectedTab === "dashboard"
                          ? "pet-det-sel-tab"
                          : "pet-det-un-sel-tab"
                      }`}
                    >
                      Dashboard
                    </div>
                  </div>
                  <div
                    className="ph10pv3"
                    onClick={() => handleChangeTab("content")}
                  >
                    <div
                      className={`flex-center cursor ${
                        selectedTab === "content"
                          ? "pet-det-sel-tab"
                          : "pet-det-un-sel-tab"
                      }`}
                    >
                      Content
                    </div>
                  </div>
                  <div className="ph10pv3">
                    <div
                      onMouseEnter={(e) => {
                        setVetAnchorEl(e.currentTarget);
                      }}
                      className={`flex-center cursor ${
                        selectedTab === "Master"
                          ? "pet-det-sel-tab"
                          : "pet-det-un-sel-tab"
                      }`}
                    >
                      Master <ArrowDropDownIcon fontSize="small" />
                    </div>
                  </div>
                  <Menu
                    anchorEl={vetAnchorEl}
                    open={Boolean(vetAnchorEl)}
                    onClose={() => setVetAnchorEl(null)}
                    MenuListProps={{
                      onMouseLeave: () => setVetAnchorEl(null),
                    }}
                  >
                    <MenuItem
                      onClick={() => {
                        setSubTab("Department");
                        setSelectedTab("Master");
                        setVetAnchorEl(null);
                      }}
                    >
                      Department
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        setSubTab("Schedule");
                        setSelectedTab("Master");
                        setVetAnchorEl(null);
                      }}
                    >
                      Schedule
                    </MenuItem>
                  </Menu>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </TopBar>
      {selectedTab === "dashboard" ? (
        <Box
          sx={{
            height: "calc(100vh - 120px)",
            overflow: "auto",
            padding: "20px",
          }}
        >
          <Main />
        </Box>
      ) : null}{" "}
      {selectedTab === "content" ? (
        <>
          <TopBar>
            <Container maxWidth="xl">
              <Toolbar variant="regular">
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="flex-row">
                    <div className="top-row-cen-con w100Per">
                      <div className="w15Per">
                        <CustomTextField
                          placeholder="Vet Name"
                          name="vetName"
                          fullWidth
                          handleChange={onSearchChange}
                          value={searchValues?.vetName}
                          backgroundColor={AppColors.lightBlue2}
                          label="Vet Name"
                          // suggetions
                          // options={vets?.vets?.map((li) => li?.name)}
                        />
                      </div>
                      <div className="w15Per ml20">
                        <Select
                          list={specialtyList}
                          value={searchValues?.speciality ?? []}
                          name="speciality"
                          handleChange={onSearchChange}
                          label="Speciality"
                          // multiSelectTagCheck
                          backgroundColor={AppColors.lightBlue2}
                          multiSelectSearchCheck
                        />
                      </div>
                      <div className="w15Per ml20">
                        <CustomTextField
                          placeholder="Phone Number"
                          name="phone"
                          fullWidth
                          handleChange={onSearchChange}
                          value={searchValues?.phone}
                          backgroundColor={AppColors.lightBlue2}
                          label="Phone Number"
                        />
                      </div>
                      <div className="w15Per ml20">
                        <CustomTextField
                          placeholder="Email"
                          name="email"
                          fullWidth
                          handleChange={onSearchChange}
                          value={searchValues?.email}
                          backgroundColor={AppColors.lightBlue2}
                          label="Email"
                        />
                      </div>
                      <div
                        className="flex-row-ali-cen ml20 filter cursor"
                        onClick={() => onFilterChange("visible", true)}
                      >
                        <TuneIcon sx={{ color: AppColors.appPrimary }} />
                        <Typography className="font-medium fs12 blue-color ml10">
                          {filterValues?.selectedList?.length > 0
                            ? `${filterValues?.selectedList?.length} `
                            : ""}
                          Filter
                        </Typography>
                      </div>
                      <div className="ml20">
                        <CustomButton
                          text="Reset"
                          onClick={onReset}
                          smallBtn
                          redBtn
                        />
                      </div>
                      <div className="ml20">
                        <CustomButton
                          text="Create"
                          onClick={handleCreate}
                          smallBtn
                        />
                      </div>
                      {/* <div className="w10Per ml20">
                        <Select
                          list={filterList}
                          value={vetFilter}
                          handleChange={(e) => {
                            setVetFilter(e?.target?.value);
                            dispatch(
                              getClinicVets(`?type=${e?.target?.value}`)
                            );
                          }}
                          name="vet"
                          select
                        />
                      </div> */}
                    </div>
                  </div>
                </Grid>
              </Toolbar>
              <Typography className="font-medium fs12 gray28">
                Number of Users: {vets?.totalRecords ?? 0}
              </Typography>
            </Container>
          </TopBar>

          <Box className="pb-40 ph20">
            <TableContainer sx={{ maxHeight: 450 }} className="mb20">
              <Table
                sx={{ minWidth: 200 }}
                aria-labelledby="tableTitle"
                stickyHeader
              >
                <TableHead>
                  <TableRow>
                    {tblHeaders?.map((hdr, i) => (
                      <TableCell
                        style={tblGrayBack}
                        className="txt-semi-bold fs12"
                      >
                        <div
                          style={{
                            width:
                              hdr === "name" ||
                              hdr === "role" ||
                              hdr === "conType"
                                ? 250
                                : hdr === "speciality"
                                  ? 230
                                  : 70,
                          }}
                        >
                          {nameExpan?.[hdr]}
                        </div>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                {
                  // (vetFilter === "all"
                  //   ? getAllFilteredList()
                  //   : vetFilter === "doctor"
                  //   ? filteredVets()
                  //   : filteredOthers()
                  // )
                  vets?.vets?.length === 0 && (
                    <TableRow>
                      <TableCell
                        colSpan={12}
                        className="text-align-center h100"
                      >
                        <div className="no-rec">No records available</div>
                      </TableCell>
                    </TableRow>
                  )
                }
                <TableBody>
                  {
                    // (vetFilter === "all"
                    //   ? getAllFilteredList()
                    //   : vetFilter === "doctor"
                    //   ? filteredVets()
                    //   : filteredOthers()
                    // )
                    vets?.vets?.map((li, i) => {
                      return (
                        <TableRow>
                          {tblHeaders?.map((hdr, ind) => (
                            <TableCell key={ind + i + "tr"} component="th">
                              <div
                                style={{
                                  width:
                                    hdr === "name" ||
                                    hdr === "role" ||
                                    hdr === "conType"
                                      ? 250
                                      : hdr === "speciality"
                                        ? 230
                                        : 70,
                                }}
                              >
                                {hdr === "name" ? (
                                  <div onClick={() => handleCardClick(li)}>
                                    <Custom3dotString
                                      str={`${
                                        li?.userType?.find(
                                          (usr) => usr?.name === "ROLE_DOCTOR",
                                        )
                                          ? "Dr. "
                                          : `${
                                              li?.salutation
                                                ? `${li?.salutation}. `
                                                : ""
                                            }`
                                      }${li?.name}`}
                                      className="font-bold fs14 capitalize cursor blue-color underline"
                                      length={20}
                                    />
                                  </div>
                                ) : hdr === "calIcon" ? (
                                  <div
                                    className="cursor"
                                    onClick={() => onClickCalendar(li)}
                                  >
                                    <CalendarMonthOutlinedIcon
                                      className="card-head-orange-color"
                                      sx={{ height: 30, width: 30 }}
                                    />
                                  </div>
                                ) : hdr === "toggleIcon" ? (
                                  <CustomSwitch
                                    value={li?.active === "Y" ? true : false}
                                    onChange={(e) => handleChangeSwitch(e, li)}
                                    greenToGray
                                  />
                                ) : hdr === "conType" ? (
                                  li?.consulationType?.length > 0 ? (
                                    li?.consulationType?.join(", ")
                                  ) : (
                                    "-"
                                  )
                                ) : (
                                  li?.[hdr]
                                )}
                              </div>
                            </TableCell>
                          ))}
                        </TableRow>
                      );
                    })
                  }
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </>
      ) : null}
      {selectedTab === "Master" ? (
        <Box
        // sx={{ padding: "20px" }}
        >
          {subTab === "Department" && <Department />}
          {subTab === "Schedule" && <Schedule />}
        </Box>
      ) : null}
      <CommonPaymentUpdateModal
        open={conModVisible}
        onClose={conModalOpen}
        onApiSuccess={handleUpdateFeeUpdateSuccess}
        vet={selectedVet}
      />
      <CustomModal
        open={filterValues?.visible}
        onClose={onCloseFilter}
        header="Filter"
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh ph20">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="gray38 fs12 txt-regular">
                Filter by:
              </Typography>
              {!filterValues?.added ? (
                filterByList?.map((li, i) => (
                  <div className="flex-row-ali-cen" key={`${i}_li`}>
                    <div>
                      <CustomCheckbox
                        checked={filterValues?.selectedList?.includes(li)}
                        onChange={() => onSelectFilter(li)}
                      />
                    </div>
                    <Typography className="txt-regular fs14 black mb5 mlMin15">
                      {li}
                    </Typography>
                  </div>
                ))
              ) : (
                <div>
                  <div
                    className="flex-row-ali-cen gray-back4 ph10 pv10 br10 width-fit-con mt10 cursor"
                    onClick={() => onFilterAdd(false)}
                  >
                    <AddIcon
                      sx={{ color: AppColors.appPrimary, fontSize: 15 }}
                    />
                    <Typography className="font-medium fs12 blue-color ml5">
                      Add Filter
                    </Typography>
                  </div>
                  {/* <div className="mt10">
                    <Select
                      list={filterList}
                      value={filterValues?.values?.type ?? []}
                      name="type"
                      handleChange={onFilterValuesChange}
                      label="Type"
                      multiSelectTagCheck
                    />
                  </div> */}
                  {/* <div className="mbminus">
                    <Checkbox
                      radio
                      name="type"
                      onChange={onFilterValuesChange}
                      radios={filterList}
                      defaultValue={filterValues?.values?.type}
                    />
                  </div> */}
                  <div>
                    {filterValues?.selectedList?.map((li) => (
                      <div className="mt20">
                        <Select
                          list={
                            li === "Type"
                              ? filterList
                              : li === "Consultation Type"
                                ? typeList
                                : li === "Role"
                                  ? [...newRoleList, ...clinicRolesList]
                                  : getDepartments()
                          }
                          value={filterValues?.values?.[li] ?? []}
                          name={li}
                          handleChange={onFilterValuesChange}
                          label={li}
                          // multiSelectTagCheck={li !== "Type"}
                          select={li === "Type"}
                          multiSelectSearchCheck={li !== "Type"}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {!filterValues?.added ? (
                <div className="flex1-end mt15">
                  <div>
                    <CustomButton
                      text="Add"
                      smallBtn
                      onClick={() => onFilterAdd(true)}
                    />
                  </div>
                </div>
              ) : (
                <div className="flex-row-center mt15">
                  <div>
                    <CustomButton
                      text="Reset All"
                      smallBtn
                      onClick={onFilterReset}
                      tabSelectdBtn
                    />
                  </div>
                  <div className="ml20">
                    <CustomButton
                      text="Apply Filters"
                      smallBtn
                      onClick={onApplyFilter}
                    />
                  </div>
                </div>
              )}
            </Grid>
          </Grid>
        </div>
      </CustomModal>
      <CustomModal
        open={createModVisible}
        onClose={createModalOpen}
        header="Create"
        rightModal
        modalWidth={30}
      >
        <Grid container spacing={1} className="ph20 scroll-90vh">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="txt-mont fs14 fw-600 ">User Type</div>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Checkbox
              radio
              onChange={handleChangeUserType}
              radios={[
                { label: "Vet", value: "Vet" },
                { label: "Other", value: "Other" },
              ]}
              defaultValue={createUserType}
            />
          </Grid>
          {createUserType === "Other" ? (
            <Grid item xs={4} sm={4} md={3} lg={3} xl={3}>
              <div className="mb20">
                <Select
                  list={salutationList}
                  value={vetValues?.salutation}
                  handleChange={(e, value) => handleSelect(value, "salutation")}
                  name="salutation"
                  label="Salutation *"
                  search
                  error={vetErrors?.salutation}
                  helperText={vetHelps?.salutation}
                />
              </div>
            </Grid>
          ) : null}
          <Grid
            item
            xs={createUserType === "Other" ? 8 : 6}
            sm={createUserType === "Other" ? 8 : 6}
            md={createUserType === "Other" ? 9 : 6}
            lg={createUserType === "Other" ? 9 : 6}
            xl={createUserType === "Other" ? 9 : 6}
          >
            <div className="mb20">
              <CustomTextField
                name="name"
                fullWidth
                required={true}
                label={"Name"}
                handleChange={handleChange}
                value={vetValues?.name}
                helperText={vetHelps?.name}
                error={vetErrors?.name}
              />
            </div>
          </Grid>
          {createUserType === "Other" || createUserType === "Vet" ? (
            <>
              <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                <div className="mb10">
                  <Select
                    list={
                      createUserType === "Vet" ? newRoleList : clinicRolesList
                    }
                    value={vetValues?.role}
                    handleChange={(e, value) => handleSelect(value, "role")}
                    required
                    label="Role *"
                    search
                    error={vetErrors?.role}
                    helperText={vetHelps?.role}
                  />
                </div>
              </Grid>
              {/* <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                <div className="mb20">
                  <Select
                    list={
                      createUserType === "Vet" ? accessList : accessListOthers
                    }
                    value={vetValues?.access}
                    handleChange={(e) => handleMultiSelect(e, "access")}
                    label="Access *"
                    multiSelectTagCheck
                    error={vetErrors?.access}
                    helperText={vetHelps?.access}
                  />
                </div>
              </Grid> */}
            </>
          ) : null}
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <div className="mb10">
              <Select
                list={getDepartments()}
                value={vetValues?.department}
                handleChange={(e, value) => handleSelect(value, "department")}
                required
                label="Department"
                search
                error={vetErrors?.department}
                helperText={vetHelps?.department}
              />
            </div>
          </Grid>
          {createUserType === "Vet" ? (
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              <div className="mb20">
                <Select
                  list={specialtyList}
                  value={vetValues?.speciality ?? []}
                  name="speciality"
                  handleChange={(e) =>
                    handleSelect(e?.target?.value, "speciality")
                  }
                  label="Speciality *"
                  error={vetErrors?.speciality}
                  helperText={vetHelps?.speciality}
                  multiSelectSearchCheck
                />
                {/* <Select
                  list={specialtyList}
                  value={vetValues?.speciality}
                  handleChange={(e, value) => handleSelect(value, "speciality")}
                  name="speciality"
                  label="Speciality *"
                  search
                  error={vetErrors?.speciality}
                  helperText={vetHelps?.speciality}
                /> */}
              </div>
            </Grid>
          ) : null}
          {/* <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <div className="mb20">
              <Select
                list={facilityList()}
                value={vetValues?.facility}
                handleChange={(e, value) => handleSelect(value, "facility")}
                name="facility"
                label="Facility"
                search
                error={vetErrors?.facility}
                helperText={vetHelps?.facility}
              />
            </div>
          </Grid> */}
          {createUserType === "Vet" ? (
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              <div className="mb20">
                <Select
                  list={typeList}
                  value={vetValues?.conType}
                  handleChange={(e) => handleMultiSelect(e, "conType")}
                  label="Consultation Type *"
                  multiSelectTagCheck
                  error={vetErrors?.conType}
                  helperText={vetHelps?.conType}
                />
              </div>
            </Grid>
          ) : null}

          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <div className="mb20">
              <CustomTextField
                value={vetValues?.contactNumber}
                handleChange={(e) =>
                  handleSelect(e?.target?.value, "contactNumber")
                }
                name="contactNumber"
                label="Phone Number"
                error={vetErrors?.contactNumber}
                fullWidth
                helperText={vetHelps?.contactNumber}
              />
            </div>
          </Grid>
          {createUserType === "Vet" ? (
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              <div className="mb20">
                <CustomTextField
                  value={vetValues?.registrationNo}
                  label="Registration No."
                  handleChange={(e) =>
                    handleSelect(e?.target?.value, "registrationNo")
                  }
                  fullWidth
                />
              </div>
            </Grid>
          ) : null}

          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <div className="mb20">
              <CustomTextField
                name="email"
                fullWidth
                handleChange={handleChange}
                label="Email"
                required={true}
                value={vetValues?.email}
                helperText={vetHelps?.email}
                error={vetErrors?.email}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <div className="mb20">
              <CustomTextField
                name="password"
                fullWidth
                handleChange={handleChange}
                value={vetValues?.password}
                helperText={vetHelps?.password}
                error={vetErrors?.password}
                label="Password"
                required={true}
                showPassword={showPassword}
                handleClickShowPassword={() => setShowPassword(!showPassword)}
                password
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Checkbox
              label="Auto-Generate Password"
              checked={isAutoGenPass}
              onChange={handleAutoGenPassword}
            />
          </Grid>
          <div className="flex1-end">
            <div>
              <CustomButton
                text="Register"
                onClick={createUserType === "Vet" ? createVet : createOther}
                smallBtn
              />
            </div>
          </div>
        </Grid>
      </CustomModal>
    </>
  );
};

export default Vets;
